"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LARGE_COMPONENT_RADIUS = void 0;
// Theme augmentation not working correctly theme.shape does not contain largeComponentRadius
// Can be deleted after resolution of issue
const LARGE_COMPONENT_RADIUS = exports.LARGE_COMPONENT_RADIUS = '10px';
